import React, { Component } from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import PropTypes from 'prop-types';

var iteration = 0

export class DataphiGrid extends Component {
    constructor(props) {
        super(props)
        this.state = { ...props }
    }
    
    componentWillReceiveProps(nextProps) {
        if (JSON.stringify(this.props) !== JSON.stringify(nextProps)) {
            this.setState({ ...nextProps })
        }
    }
    
    getTableFormat = (cell, row, formatExtraData, rowIdx, col) => {
        const { keyField } = this.state
        ++iteration
        //if(Boolean(col.phiDataFormat))
        function getCellData(cell, row, column, rowIdx, col) {
            iteration = iteration % 4 === 0 ? 0 : column
            if (Boolean(col.phiDataFormat)) {
                let unqIdentifier = `cell_${row[`${keyField}`]}${column}`
                return <div>{col.phiDataFormat(cell, row, unqIdentifier)}</div>
            } else {
                return <div id={`cell_${row.id}${column}`}>{cell}</div>
            }
        }
        return getCellData(cell, row, iteration, rowIdx, col)
    }
    
    render() {
        return (
            <div>
                <BootstrapTable
                    {...this.state}
                >
                    {
                        this.state.tableHeaderColumn.map((col, i) => {
                            return (
                                <TableHeaderColumn
                                    dataFormat={
                                        (cell, row, formatExtraData, rowIds) => this.getTableFormat(cell, row, formatExtraData, rowIds, col)
                                    }
                                    key={i}
                                    {...col}
                                >
                                    {col.value}
                                </TableHeaderColumn>
                            )
                        })
                    }
                </BootstrapTable>
            </div>
        );
    }
}

// DataphiGrid.PropTypes = {
//     data: PropTypes.array.isRequired,
//     tableHeaderColumn: PropTypes.array.isRequired,
//     keyField: PropTypes.string.isRequired
// }

DataphiGrid.defaultProps = {
    data: [],
    tableHeaderColumn: [],
    keyField: ''
}
/* 
class PaginationPanel extends Component
 */
export const PaginationPanel = (props) => {
    let paginationSize = props.paginationSize
    let currentPage = props.currentPage
    let iterationFrom = currentPage - (Math.floor(paginationSize / 2))
    let iterationUpto = (iterationFrom + paginationSize) - 1
    let { pages, goToThisPage } = props

    function paginationItem() {
        let listItem = []
        for (let i = iterationFrom; i <= iterationUpto; i++) {
            if (i > 0 && i <= pages) {
                listItem.push(
                    <li key={i} className={i === currentPage ? 'active' : null} onClick={() => goToThisPage(i)}>
                        <button className={'btn '+(i === currentPage ? 'btn-success' : 'btn-light')}>
                            <span aria-hidden="true">{i}</span>
                        </button>
                    </li>
                )
            }
        }
        return listItem
    }
    return (
        <div className="row">
            <div className="col-md-6">
                <span>Change size per page: </span>
                {props.props.components.sizePerPageDropdown}
            </div>
            <div className="col-md-6">
                <div style={{ float: 'right', marginTop: '-20px' }}>
                    <nav aria-label="Page navigation">
                        <ul className="pagination">
                            {
                                currentPage > 1
                                &&
                                <li onClick={() => goToThisPage(1)}>
                                    <button className="btn btn-light" aria-label="First">
                                        <span aria-hidden="true">&laquo;</span>
                                    </button>
                                </li>
                            }
                            {
                                currentPage > 1
                                &&
                                <li onClick={() => goToThisPage(currentPage - 1)}>
                                    <button className="btn btn-light" aria-label="Previous">
                                        <span aria-hidden="true">&lt;</span>
                                    </button>
                                </li>
                            }
                            {
                                paginationItem()
                            }
                            {
                                currentPage !== props.pages
                                &&
                                <li onClick={() => goToThisPage(currentPage + 1)}>
                                    <button className="btn btn-light" aria-label="Next">
                                        <span aria-hidden="true">&gt;</span>
                                    </button>
                                </li>
                            }
                            {
                                currentPage !== props.pages
                                &&
                                <li onClick={() => goToThisPage(pages)}>
                                    <button className="btn btn-light" aria-label="Last">
                                        <span aria-hidden="true">&raquo;</span>
                                    </button>
                                </li>
                            }
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    );
}

// PaginationPanel.PropTypes = {
//     paginationSize: PropTypes.number,
//     currentPage: PropTypes.number,
//     pages: PropTypes.number,
//     goToThisPage: PropTypes.func,
//     props: PropTypes.object
// }